import React, { useState } from "react";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// core components
import Grid from "@mui/material/Grid";

import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloBotonera from '../componentsothello/OthelloBotonera.jsx';
import { TipoOthelloFieldGrid, DataStatePage, OpcionSiNo, TipoArea, TiposArea, OrdenacionPois, OpcionVisibilidad, Roles, PopUpResult, ModosRuta, MetodosRuta, ModelosArea, OpcionVisibilidadWeb } from "../othelloConstantes.jsx";
import OthelloGrid from '../componentsothello/OthelloGrid.jsx';
import OthelloEdit  from '../componentsothello/OthelloEdit.jsx';
import ImageUpload from "../components/ImageUpload.jsx";
import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData.jsx";


export default function Areas({ ...props }) {
    const { literal, idRol } = props;

    const [loading, setLoading] = React.useState(true);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);
    const [stateSubPage, setstateSubPage] = React.useState(DataStatePage.dsSearch);
    const [dataareas, setdataareas] = React.useState(null);
    const [datasubareas, setdatasubareas] = React.useState(null);
    const [idiomas, setidiomas] = React.useState(null);
    const [tipoareaselected, settipoareaselected] = React.useState(null);
    const [esrutaselected, setesrutaselected] = React.useState(null);

    const [alert, setalert] = React.useState(null);

    const [dataeditando, setdataeditando] = useState(null);
    const [indexeditando, setindexeditando] = useState(null);

    const [datasubareaeditando, setdatasubareaeditando] = useState(null);
    const [indexsubareaeditando, setindexsubareaeditando] = useState(null);


    React.useEffect(() => {

        setLoading(false);
        getDataPage();
    }, [loading]);

    const getDataPage = () => {

        fetch('api/Data/GetIdiomas')
            .then(response => response.json())
            .then(data => {

                let residiomas = data.map(x => {
                    let val =
                    {
                        ...x,
                        valor: x.idioma,
                        name: x.descripcion
                    };

                    return val;

                })

                setidiomas(residiomas);
            });

        fetch('api/Data/GetAreas')
            .then(response => response.json())
            .then(res => {
                setdataareas(res);               
            });
    }

    const getDataVacio = () => {

        fetch('api/Data/GetAreaVacia')
            .then(response => response.json())
            .then(data => {
                setindexeditando(-1);
                setdataeditando(data);
                setstatePage(DataStatePage.dsInsert);
               // setdialogeditando(ModoModal.New);
            }).catch(error => {
                setindexeditando(-1);
                setdataeditando(null);
            });
    }

    const grabarDataPage = (event) => {

        //Obtengo los datos
          let formulario = document.getElementById('formarea');
          let formData = new FormData(formulario);
          //const data = new FormData(this.refs.form);
  
          fetch('api/Data/GrabarArea', {
              method: 'POST',
              body: formData,
  
          }).then(response => response.json()).then(res => {

              if (indexeditando == -1) {

                  var array = [...dataareas];
                  array.push(res);
                  setdataareas(array);
              }
              else {
                  var array = [...dataareas];
                  array[indexeditando] = res;
                  setdataareas(array);
              }

              setdataeditando(null);
              setindexeditando(null);
              setdatasubareaeditando(null);
              setindexsubareaeditando(null);
              setstatePage(DataStatePage.dsSearch);

              setalert(PopUpResult.OK);

          }).catch(error => {
              setalert(PopUpResult.KO);
          }); 
    }

    const nuevoDataPage = () => {
        getDataVacio();
        setindexeditando(-1);
    }


    const cancelarDataPage = () => {

        setdataeditando(null);
        setindexeditando(null);
        setdatasubareaeditando(null);
        setindexsubareaeditando(null);
        setstatePage(DataStatePage.dsSearch);

    }

    const deshacerDataPage = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditando == -1)
            setstatePage(DataStatePage.dsSearch);
        //Sino, es que estabamos en un item valido
       // else
         //   forceUpdate()
    }

    const onChangeTipoArea = (valor) => {

        if (tipoareaselected != valor) {
            var object = {};
            let formulario = document.getElementById('formarea');
            let formData = new FormData(formulario);
            formData.forEach((value, key) => { object[key] = value });

            setdataeditando(object);
            settipoareaselected(valor);
        }
    }

    const onChangeEsRuta = (valor) => {
        if (esrutaselected != valor) {
            var object = {};
            let formulario = document.getElementById('formarea');
            let formData = new FormData(formulario);
            formData.forEach((value, key) => { object[key] = value });

            setdataeditando(object);

            setesrutaselected(valor);
        }
    }

    const onClosePopUpResult = () => {
        setalert(null);        
    }

    //Metodoso sobre SubAreas

    const getDataVaciaSubArea = () => {

        var jsonData = JSON.stringify({ id_area: dataeditando.id_Area, idioma: dataeditando.idioma });

        fetch('api/Data/GetSubAreaVacia', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res =>
        {
            setdatasubareaeditando(res);
            setstateSubPage(DataStatePage.dsInsert );                        
        }).catch(error => {
            setdatasubareaeditando(null);            
        });
    }

    const grabarDataPageSubArea = (event) =>
    {
        //Obtengo los datos
        let formulario = document.getElementById('formsubarea');
        let formData = new FormData(formulario);
        //const data = new FormData(this.refs.form);

        fetch('api/Data/GrabarSubArea', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            if (indexsubareaeditando == -1) {

                var array = [...datasubareas];
                array.push(res);
                setdatasubareas(array);
            }
            else {
                var array = [...datasubareas];
                array[indexsubareaeditando] = res;
                setdatasubareas(array);
            }          

            setdatasubareaeditando(null);
            setindexsubareaeditando(null);
            setstateSubPage(DataStatePage.dsSearch);

            setalert(PopUpResult.OK);

        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPageSubArea = () => {
        //LLama a obtener el idioma vacio, que es el que pondra el estado
        getDataVaciaSubArea();
        setindexsubareaeditando(-1);        
    }

    const cancelarDataPageSubArea = () => {
        setdatasubareaeditando(null);
        setindexsubareaeditando(null);
        setstateSubPage(DataStatePage.dsSearch);
    }

    const deshacerDataPageSubArea = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexsubareaeditando == -1)
            setstateSubPage(DataStatePage.dsSearch);            
        //Sino, es que estabamos en un item valido
        //else
          //  forceUpdate()
    }

    //METODO SOBRE EL GRID AREAS   
    const editGridDataPage = (valor, index) => {

        setdataeditando(valor);
        setindexeditando(index);
        
        //Al editar otra concreta limpiamos la posible subarea seleccionada
        setdatasubareaeditando(null);
        setindexsubareaeditando(null);

        //Si no tiene subareas entonces directamente lo pongo en edicion y limpio la lista de subareas
        if (valor.tieneSubAreas == 0)
        {
            settipoareaselected(valor.tipoArea);
            setesrutaselected(valor.esRuta);
            setdatasubareas([]);
            setstatePage(DataStatePage.dsEdit);
            setstateSubPage(DataStatePage.dsSearch);
        }
        //sino, es que tiene subareas, por tanto las pido
        else {
            if (valor != null) {
                var jsonData = JSON.stringify(valor.id_Area);

                fetch('api/Data/GetSubAreas', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res =>
                {
                    settipoareaselected(valor.tipoArea);
                    setesrutaselected(valor.esRuta);
                    setdatasubareas(res);
                    setstatePage(DataStatePage.dsEdit);
                    setstateSubPage(DataStatePage.dsSearch);
                }).catch(error => {

                });
            }
        }
    }

    const deleteGridDataPage = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Area);

            fetch('api/Data/EliminarArea', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                if (res) {
                    //Si todo salie correcto limpio los valores de edicion
                    setdataeditando(valor);
                    setindexeditando(index);
                    
                    if (dataareas != null) {
                        var array = [...dataareas]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdataareas(array);                        
                        setdatasubareas([]);
                        setstatePage(DataStatePage.dsSearch);
                        setstateSubPage(DataStatePage.dsSearch);
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);                
            });
        }
    }

    //METODO SOBRE EL GRID SUBAREAS
    const editGridDataPageSubArea = (valor, index) => {

        setdatasubareaeditando(valor);
        setindexsubareaeditando(index);
        setstateSubPage(DataStatePage.dsEdit);        
    }

    const deleteGridDataPageSubArea = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_SubArea);

            fetch('api/Data/EliminarSubArea', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {
                    //Si todo salie correcto limpio los valores de edicion
                    setdatasubareaeditando(valor);
                    setindexsubareaeditando(index);
                    

                    if (datasubareas != null) {
                        var array = [...datasubareas]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdatasubareas(array);
                        setalert(PopUpResult.OK);                       
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    //METODOS DE RENDERIZADO DE LA PANTALLA

    function renderSearch(areas) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = idRol == Roles.SuperUsuario ? ["Area", "Nombre", "Idioma", "Tipo", "Ruta", "Ordenado", "Opinion", "Notifica", "Orden", "Visible", "Todas", "Icono", "Imagen", "Sub Areas"/*, "Accion"*/] :
            ["Nombre", "Idioma", "Tipo", "Ruta", "Ordenado", "Opinion", "Notifica", "Orden", "Visible", "Todas", "Icono", "Imagen", "Sub Areas"/*, "Accion"*/];

        let valoreshow = idRol == Roles.SuperUsuario ? ["id_Area", "cod_Area", "idioma", "tipoArea", "esRuta", "ordenadoPor", "permiteOpiniones", "permiteNotificar", "ordenVisual", "visible", "tieneOpcionTodas", "image", "imageAux", "tieneSubAreas"/*, "url"*/] :
            ["cod_Area", "idioma", "tipoArea", "esRuta", "ordenadoPor", "permiteOpiniones", "permiteNotificar", "ordenVisual", "visible", "tieneOpcionTodas", "image", "imageAux", "tieneSubAreas"/*, "url"*/];;


        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "idioma", items: idiomas });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "tipoArea", items: TiposArea });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "esRuta", items: OpcionSiNo });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "ordenadoPor", items: OrdenacionPois });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "permiteOpiniones", items: OpcionSiNo });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "permiteNotificar", items: OpcionSiNo });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "visible", items: OpcionVisibilidad });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "tieneOpcionTodas", items: OpcionSiNo });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "image", items: [] });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "imageAux", items: [] });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={areas != null ? areas : []} datasourcefields={datasourceFields} onEdit={editGridDataPage} onDelete={deleteGridDataPage} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={10} />);
    }

    function renderInsertEdit(area)
    {
        if (area != null) {
            let Nombre = area != null && area.id_Area > 0 ? "Editar " + area.cod_Area : "Nueva Area";

            let infosubareas = renderOpcionesSubAreas();

            return (

                <OthelloTituloPanelData icon="near_me" titulo={Nombre} margentop={4}>
                    <div style={{ backgroundColor: '#FFFFFF' }}>
                        <Grid container>
                            <Grid item xs={12} >
                                <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} onGrabar={grabarDataPage} onCancel={cancelarDataPage} onDeshacer={deshacerDataPage} />
                            </Grid>
                        </Grid>
                        <form id="formarea" >
                            <Grid container>
                                <input id="Id_Oficina" name="id_Oficina" type="hidden" value={area.id_Oficina} />
                                <input id="Id_Area" name="id_Area" type="hidden" value={area.id_Area} />
                                <Grid item xs={12} sm={2} lg={1}>
                                    <OthelloEdit label="Nombre" fieldname="cod_Area" currentvalue={area.cod_Area} />
                                </Grid>
                                <Grid item xs={6} sm={2} lg={1}>
                                    <OthelloComboBox label='Idioma' fieldname="idioma" items={idiomas} currentvalue={area.idioma} />
                                </Grid>
                                <Grid item xs={6} sm={2} lg={1}>
                                    <OthelloComboBox label='Tipo Area' fieldname="tipoArea" items={TiposArea} currentvalue={area.tipoArea} onChange={onChangeTipoArea} />
                                </Grid>
                                {
                                    tipoareaselected == TipoArea.Normal || tipoareaselected == TipoArea.Principal ?
                                        <Grid item xs={12} sm={2} lg={1}>
                                            <OthelloComboBox label='Skin' fieldname="Id_Interfaz" items={ModelosArea} currentvalue={area.id_Interfaz} />
                                        </Grid> : ""
                                }
                                {
                                    tipoareaselected == TipoArea.Normal || tipoareaselected == TipoArea.Principal ?
                                        (<Grid item xs={6} sm={2} lg={1}>
                                            <OthelloComboBox label='Es Ruta' fieldname="esRuta" items={OpcionSiNo} currentvalue={area.esRuta} onChange={onChangeEsRuta} />
                                        </Grid>) : ""
                                }
                                {
                                    tipoareaselected == TipoArea.Normal || tipoareaselected == TipoArea.Principal || tipoareaselected == TipoArea.Agenda ?
                                        <Grid item xs={6} sm={2} lg={1}>
                                            <OthelloComboBox label='Ordenado' fieldname="ordenadoPor" items={OrdenacionPois} currentvalue={area.ordenadoPor} />
                                        </Grid> : ""
                                }
                                {
                                    tipoareaselected == TipoArea.Normal || tipoareaselected == TipoArea.Principal ?
                                        (<Grid item xs={6} sm={2} lg={1}>
                                            <OthelloComboBox label='Opinion' fieldname="permiteOpiniones" items={OpcionSiNo} currentvalue={area.permiteOpiniones} />
                                        </Grid>) : ""
                                }

                                <Grid item xs={6} sm={2} lg={1}>
                                    <OthelloComboBox label='Notifica' fieldname="permiteNotificar" items={OpcionSiNo} currentvalue={area.permiteNotificar} />
                                </Grid>
                                <Grid item xs={6} sm={2} lg={1}>
                                    <OthelloEdit label="Orden Visual" fieldname="ordenVisual" currentvalue={area.ordenVisual} />
                                </Grid>
                                <Grid item xs={6} sm={2} lg={1}>
                                    <OthelloComboBox label='Visible' fieldname="visible" items={OpcionVisibilidad} currentvalue={area.visible} />
                                </Grid>
                                <Grid item xs={6} sm={3} lg={1}>
                                    <OthelloComboBox label='Opcion Todas' fieldname="tieneOpcionTodas" items={OpcionSiNo} currentvalue={area.tieneOpcionTodas} />
                                </Grid>
                                {
                                    tipoareaselected == TipoArea.Web || tipoareaselected == TipoArea.Externo || tipoareaselected == TipoArea.Tiempo || tipoareaselected == TipoArea.Telefono
                                        || tipoareaselected == TipoArea.Whastapp ?
                                        (<Grid item xs={6} sm={3}>
                                            <OthelloEdit label="Accion" fieldname="url" currentvalue={area.url != null ? area.url : ""} />
                                        </Grid>) : ""
                                }
                            </Grid>
                            {
                                esrutaselected == "1" ?
                                    <Grid container>
                                        <Grid item xs={6} sm={2}>
                                            <OthelloComboBox label='ModoRuta' fieldname="modoRuta" items={ModosRuta} currentvalue={area.modoRuta} />
                                        </Grid>
                                        <Grid item xs={6} sm={2}>
                                            <OthelloComboBox label='MetodoRuta' fieldname="metodoRuta" items={MetodosRuta} currentvalue={area.metodoRuta} />
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <OthelloEdit label="WayPoints Manual (lat,lon|lat,lon)" fieldname="wayPoints" currentvalue={area.wayPoints != null ? area.wayPoints : ""} />
                                        </Grid>
                                    </Grid> :
                                    <div>
                                        <input id="modoRuta" name="modoRuta" type="hidden" value={area.modoRuta} />
                                        <input id="wayPoints" name="wayPoints" type="hidden" value={""} />
                                        <input id="metodoRuta" name="metodoRuta" type="hidden" value={0} />
                                    </div>
                            }
                            <Grid container>
                                <Grid item xs={6} sm={2} lg={1}>
                                    <OthelloComboBox label='VisibleHomeWeb' fieldname="visibleHomeWeb" items={OpcionVisibilidadWeb} currentvalue={area.visibleHomeWeb} />
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={6} sm={2}>
                                    <br />
                                    <legend>Icono (48x48px)</legend>
                                    <ImageUpload
                                        id="Image" name="image"
                                        imageUrl={area.image}
                                        addButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        changeButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        removeButtonProps={{
                                            color: "danger",
                                            round: true
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={2}>
                                    <br />
                                    <legend>Imagen</legend>
                                    <ImageUpload
                                        id="ImageAux" name="imageAux"
                                        imageUrl={area.imageAux}
                                        addButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        changeButtonProps={{
                                            color: "rose",
                                            round: true
                                        }}
                                        removeButtonProps={{
                                            color: "danger",
                                            round: true
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </form>
                        <Grid container>
                            <Grid item xs={12} >
                                {infosubareas}
                            </Grid>
                        </Grid>
                    </div>
                </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    function renderOpcionesSubAreas() {
        let busquedaSubAreas = renderSearchSubAreas(datasubareas);

        let edicion = stateSubPage == DataStatePage.dsEdit || stateSubPage == DataStatePage.dsInsert ? renderInsertEditSubArea(datasubareaeditando) : "";
        //#99d9b7
        return (
            <OthelloTituloPanelData icon="layers" tituloliteral="_subareas" margentop={4} backcoloretiqueta="#709e86" bgcoloricon="success">            
            <div style={{ backgroundColor: '#FFFFFF' }}>
                <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                        {edicion}
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={stateSubPage} onNuevo={nuevoDataPageSubArea} forzarnuevo={true} />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} >
                        {busquedaSubAreas}
                    </Grid>
                </Grid>
            </div>
        </OthelloTituloPanelData>);
    }

    function renderSearchSubAreas(subareas) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = idRol == Roles.SuperUsuario ? ["Sub Area", "Nombre", "Orden Visual", "Icono", "Imagen"] : ["Nombre", "Orden Visual", "Icono", "Imagen"];
        let valoreshow = idRol == Roles.SuperUsuario ? ["id_SubArea", "descripcion", "ordenVisual", "image", "imageAux"] : ["descripcion", "ordenVisual", "image", "imageAux"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "image", items: [] });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloImagen, fieldname: "imageAux", items: [] });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={subareas} datasourcefields={datasourceFields} onEdit={editGridDataPageSubArea} onDelete={deleteGridDataPageSubArea} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={5} />);
    }

    function renderInsertEditSubArea(subarea) {
        if (subarea != null) {
            let Nombre = subarea != null && subarea.id_SubArea > 0 ? "Editar " + subarea.descripcion : "Nueva Sub Area";

            return (<div style={{ backgroundColor: '#f0f0f0', padding: '10px', marginBottom: '10px' }}>
                <Grid container xs={12}>
                    <Grid item xs={12} >
                        <h4>{Nombre}</h4>
                    </Grid>
                </Grid>
                <Grid container xs={12}>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPageSubArea} onGrabar={grabarDataPageSubArea} onCancel={cancelarDataPageSubArea} onDeshacer={deshacerDataPageSubArea} />
                    </Grid>
                </Grid>
                <form id="formsubarea" >
                    <Grid container xs={12}>
                        <input id="Id_Oficina" name="Id_Oficina" type="hidden" value={subarea.id_Oficina} />
                        <input id="Id_Area" name="Id_Area" type="hidden" value={subarea.id_Area} />
                        <input id="Id_SubArea" name="Id_SubArea" type="hidden" value={subarea.id_SubArea} />
                        <input id="Idioma" name="Idioma" type="hidden" value={subarea.idioma} />
                        <Grid item xs={12} sm={3} lg={1}>
                            <OthelloEdit label="Nombre" fieldname="Descripcion" currentvalue={subarea.descripcion} />
                        </Grid>
                        <Grid item xs={12} sm={3} lg={3}>
                            <OthelloEdit label="WayPoints Manual (lat,lon|lat,lon)" fieldname="WayPoints" currentvalue={subarea.wayPoints} />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <OthelloEdit label="Orden Visual" fieldname="OrdenVisual" currentvalue={subarea.ordenVisual} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} sm={2}>
                            <br />
                            <legend>Icono (48x48px)</legend>
                            <ImageUpload
                                id="Image" name="Image"
                                imageUrl={subarea.image}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <br />
                            <legend>Imagen</legend>
                            <ImageUpload
                                id="ImageAux" name="ImageAux"
                                imageUrl={subarea.imageAux}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                    </Grid>
                </form>
            </div>
            );
        }
        else
            return "";
    }



    let busqueda = loading ? <p><CircularProgress color="secondary" /></p>
        : renderSearch(dataareas)

    let edicion = statePage == DataStatePage.dsEdit || statePage == DataStatePage.dsInsert ? renderInsertEdit(dataeditando) : "";

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                {alerta}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                {edicion}
            </Grid>
            <Grid container>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} forzarnuevo={true} />
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData tituloliteral="_areas" margentop={0}>
                    <Grid container>
                        <Grid item xs={12}>
                            {busqueda}
                        </Grid>
                    </Grid>
                </OthelloTituloPanelData>

                {/*<Card style={{ backgroundColor: '#6C757D' }}>*/}
                {/*    <div color="rose" icon>*/}
                {/*        <div color="rose">*/}
                {/*            <NearMe />*/}
                {/*        </div>*/}
                {/*        <h4>Areas</h4>*/}
                {/*    </div>*/}
                {/*    <div style={{ backgroundColor: '#FFFFFF' }}>*/}
                {/*        <Grid container>*/}
                {/*            <Grid item xs={12} >*/}
                {/*                <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} forzarnuevo={true} />*/}
                {/*            </Grid>*/}
                {/*        </Grid>*/}
                {/*        <Grid container>*/}
                {/*            <Grid item xs={12} >*/}
                {/*                {busqueda}*/}
                {/*            </Grid>*/}
                {/*        </Grid>*/}
                {/*    </div>*/}
                {/*</Card>*/}
            </Grid>
        </Grid>
    );
}

